import { Typography } from '@mui/material';
import type { FileSearchRecord } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';

import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';

export const PathCell = ({ entity }: { entity: FileSearchRecord }) => {
  const { isAuthorized } = useRoles();
  return (
    entity.path && (
      <TextLink
        disabled={!isAuthorized('read:files')}
        href={`/explorer/${entity.resourceId}?file=${Base64.encode(entity.path)}`}
      >
        <Typography className='hover:text-[var(--mui-palette-text-secondary)]'>
          {entity.path}
        </Typography>
      </TextLink>
    )
  );
};
